module.exports = __webpack_public_path__ + "img/share_your_campaign.6567909d.png";